const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const localeUtils = require('utils/LanguageLocale');
const { addRwdHeaders } = require('utils/Api');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Keyword+Search+API

function searchProductsByKeyword(options) {
    const {
        catalogId,
        config = {},
        ...opts
    } = options;

    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;

    let url = `/api/catalog/search/?type=keyword&q=${catalogId}`;
    const getRefinement = function (){
        if (opts.ref && opts.ref.split(',').length) {
            opts.ref.split(',').forEach(refinement => url += `&ref=${refinement}`);
            delete opts.ref;
        }
    };

    if (isNLPInstrumentationEnabled){
        if (isNLPSearchEnabled && constructorSessionID && constructorClientID) {
            url = url + `&constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=nlp`;
            getRefinement();
        }
    } else {
        url = url + '&targetSearchEngine=nlp';
        getRefinement();
    }

    if (Object.keys(opts).length) {
        url += '&' + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }, config).
        then(data => data.errorCode ? Promise.reject(data) : data);
}

function getProductsFromKeyword({
    headers: headersArg, config = {}, ...options
}) {
    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    let url = '/api/catalog/search';

    const queryStringObject = {
        type: 'keyword',
        content: true,
        includeRegionsMap: true,
        targetSearchEngine: 'nlp',
        countryCode: localeUtils.isCanada() ? localeUtils.COUNTRIES.CA : localeUtils.COUNTRIES.US,
        ...options
    };

    if (Object.keys(queryStringObject).length) {
        url += '?' + urlUtils.makeQueryString(queryStringObject);
    }

    if (isNLPInstrumentationEnabled){
        if (isNLPSearchEnabled && constructorSessionID && constructorClientID) {
            url = url + `&constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}`;
        }
    }

    const headers = addRwdHeaders(headersArg);

    return ufeApi.makeRequest(url, {
        method: 'GET',
        headers
    }, config)
        .then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = {
    searchProductsByKeyword,
    getProductsFromKeyword
};
